module.exports = __webpack_public_path__ + "static/img/ss3-1.f27a10b9.png";